import { finiteOrNull, plural } from "../../services/moksha-reservations/format";

const money = (n) => Math.abs(n).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const formatMoney = (n) => {
    const value = Number(n) || 0;
    return `${value < 0 ? "−" : ""}₹${money(value)}`;
};

export const focusRing = (colors) => ({
    "&.Mui-focusVisible": { outline: `2px solid ${colors.blueAccent[500]}`, outlineOffset: "2px" },
});

// The teal accent is ~1.5:1 on the light greys, so light mode uses its darkest usable shade.
export const accentText = (colors, mode) => (mode === "dark" ? colors.greenAccent[500] : colors.greenAccent[200]);

// field(id, hint) → error/helperText/onBlur props; a message shows only once the field is touched.
export const makeField = (errors, touched, touch) => (id, hint = " ") => {
    const message = touched[id] ? errors[id] || "" : "";
    return { error: !!message, helperText: message || hint, onBlur: () => touch(id) };
};

const parts = (values) => {
    const [adults, children, guests] = [values.adults, values.children, values.guests].map(finiteOrNull);
    return [
        adults !== null && plural(adults, "adult"),
        children !== null && plural(children, "child", "children"),
        guests !== null && plural(guests, "guest"),
    ].filter(Boolean);
};

export const capacityLabel = (roomtype) => {
    const found = parts({ adults: roomtype?.max_adults, children: roomtype?.max_children, guests: roomtype?.max_occupancy });
    return found.length ? `Max ${found.join(" · ")}` : "";
};

export const capacitySummary = ({ rooms, maxAdults, maxChildren, maxGuests }) => {
    const found = parts({ adults: maxAdults, children: maxChildren, guests: maxGuests });
    return rooms && found.length
        ? `Your ${plural(rooms, "room")} ${rooms === 1 ? "holds" : "hold"} up to ${found.join(", ")}.`
        : "";
};
